import renderer, { removeUpsell } from '../renderer';
import { PAGE } from '../domain';
import errorHandler from '../errorHandler';
import { getAppProps } from '../utils';
import { sortAddOns } from '../addOnsUtil';
import getCatalogAddOns from '../catalogAddOns';
import { addOnAddToCartActionHander } from '../cartActionHandler';

function prepareAddons({ variantToIgnore, groupVairantsTracker }) {
  const { addOnsDb } = getAppProps();
  const addOnsTracker = {};
  const addOns = [];
  const allProductAddOns = getCatalogAddOns(
    addOnsDb,
    addOnsTracker,
    variantToIgnore,
    groupVairantsTracker
  );
  addOns.push.apply(addOns, allProductAddOns);
  return addOns;
}

function prepareItems() {
  const { options } = getAppProps();

  let variantToIgnore = {};
  const groupVairantsTracker = options.groupVariants ? {} : null;

  const addOns = prepareAddons({
    variantToIgnore,
    groupVairantsTracker
  });

  if (groupVairantsTracker) {
    for (let groupedVariant in groupVairantsTracker) {
      addOns.push(groupVairantsTracker[groupedVariant]);
    }
  }
  const filter = addOns.filter(v => v.thankYouPage === true);
  return sortAddOns(filter);
}

export default function orderStatusPage() {
  try {
    const { options } = getAppProps();
    addOnAddToCartActionHander(false, options);

    const sortedAddOns = prepareItems();
    renderer(sortedAddOns, [], PAGE.OrderStatus);
  } catch (err) {
    removeUpsell();
    errorHandler(err);
  }
}
